import { Row } from 'antd';
import { TRecentSearch } from './definitions';

import Styles from './RecentSearch.module.scss';

import { useDeleteRecentSearch } from 'Pages/Home/Hooks/useDeleteRecentSearch';
import { useFetchRecentSearchData } from 'Pages/Home/Hooks/useFetchRecentSearchData';
import { useHistory } from 'react-router';
import ButtonCard from '../../Atoms/ButtonCard';
import RecentButton from '../../Atoms/RecentButton';
import RecentTitle from '../../Atoms/RecentTitle';
import useSaveSearch from 'Pages/Home/Hooks/useSaveSearch';

export default function RecentSearch({
  title,
  rightTitle,
  afterClick,
  userId,
}: TRecentSearch) {
  const history = useHistory();
  const { data, fetchData } = useFetchRecentSearchData(6);
  const { postSaveSearchActivity } = useSaveSearch({
    category: 'all_category',
    userId,
  });

  const onRecentSearchClick = (query: string) => {
    if (userId) {
      postSaveSearchActivity(query);
    }
    history.push(`/search?keyword=${query.split(' ').join('+')}`);
    afterClick();
  };

  const onDeleteItemRecentSearch = (id: number) => {
    useDeleteRecentSearch(id).then(() => {
      fetchData();
    });
  };

  const onDeleteAllRecentSearch = () => {
    useDeleteRecentSearch().then(() => {
      fetchData();
    });
  };

  if (data.length === 0)
    return <div className={Styles['empty-recent-search']} />;
  return (
    <Row className={Styles['recent-search-row']}>
      <Row
        justify="space-between"
        align="middle"
        className={Styles['recent-search-title']}
      >
        <RecentTitle text={title} />
        <RecentButton text={rightTitle} onClick={onDeleteAllRecentSearch} />
      </Row>
      <Row align="middle" className={Styles['recent-search-item']}>
        {data.map((item, index) => (
          <ButtonCard
            withX
            onClick={() => onRecentSearchClick(item.query)}
            onClickX={() => onDeleteItemRecentSearch(item.id)}
            text={item.query}
            className={Styles['recent-search-item-col']}
          />
        ))}
      </Row>
    </Row>
  );
}
